import * as React from 'react'
import { forwardRef } from 'react'
import { IconCamera } from '@tabler/icons'
import cx from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import UploaderFile from '../UploaderFile'
import UploaderErrors from '../UploaderErrors'

const placeholder = <div className="uploader-take-a-picture__placeholder">
  <div>
    <IconCamera size={50} />
  </div>
  <span><FormattedMessage defaultMessage='Press To Take A Photo'/></span>
</div>

const UploadTakeAPicture: Uploader.UploadPresentationalComponent = (
  { upload, value, errors, fullWidth, addingFiles, uploading, onClick, onChange, onReset, onErrorClose },
  ref
) => {
  const intl = useIntl()
  return (
    <div className={cx('uploader', fullWidth && 'uploader--full')}>
      <div className="uploader-take-a-picture">
        <UploaderFile
          file={value}
          hasError={errors.length > 0}
          onClick={onClick}
          onRemove={onReset}
          placeholder={placeholder}
          changeFileText={intl.formatMessage({ defaultMessage: 'Take A Photo' })}
          addingFiles={addingFiles}
          uploading={uploading}
          fit
        />
        <UploaderErrors errors={errors} constraints={upload.getConstraints()} onErrorClose={onErrorClose} />
      </div>

      <input
        ref={ref}
        className="uploader__input"
        type="file"
        onChange={onChange}
        accept={upload.getAllowedMimeTypesAsAcceptAttribute()}
        multiple={upload.isMultiple()}
        capture
      />
    </div>
  )
}
export default forwardRef(UploadTakeAPicture)
